"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
require("../../styles/TabButton.styles.css"); //TODO: add styles bro
const TabButton = ({ label, to, onPress, icon, target, external = false }) => {
    const activeClasses = "tab-button fw-bold p-2 px-3 text-decoration-none border-bottom link-primary border-primary border-4 ";
    const inactiveClasses = "tab-button link-dark fw-bold p-2 px-3  text-decoration-none";
    const content = ((0, jsx_runtime_1.jsxs)("span", { className: "text-nowrap", children: [icon && (0, jsx_runtime_1.jsx)("span", { className: "pe-1", children: icon }), " ", label] }));
    if (!to) {
        return ((0, jsx_runtime_1.jsx)("a", { href: "#", className: inactiveClasses, onClick: onPress, children: content }));
    }
    if (external) {
        return ((0, jsx_runtime_1.jsx)("a", { href: to, className: inactiveClasses, target: target, onClick: onPress, children: content }));
    }
    return ((0, jsx_runtime_1.jsx)(react_router_dom_1.NavLink, { className: ({ isActive }) => isActive ? activeClasses : inactiveClasses, end: true, to: to, target: target, onClick: onPress, children: content }));
};
exports.TabButton = TabButton;
